import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getDispositionsByPlantId } from '../../api/production-request-api/index.js';
import { useAppContext } from '../../providers';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to retrieve all dispositions for a given plant.
 */
export const useDispositions = () => {
  const { apiReady } = useApiReady();
  const { selectedPlant } = useAppContext();

  return useQuery({
    queryKey: [QUERY_KEYS.DISPOSITIONS, selectedPlant],
    queryFn: () => getDispositionsByPlantId(selectedPlant),
    enabled: Boolean(apiReady && selectedPlant),
  });
};
